var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"transition dark:text-white",class:[_vm.bg, 'hover:' + _vm.hoverBg, 'dark:' + _vm.darkBg, 'dark:hover:' + _vm.darkHoverBg, _vm.dividerClasses]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }